import React, { useEffect, useState } from 'react'
import { groups } from 'd3-array'
import './styles.scss'
import LineAndPoints from 'components/Charts_LineAndPoints'
import { addDays, formatSwissDate } from 'components/Charts_Assets'
import Chart from 'components/Charts_Chart'

const showMax = window.innerWidth > 599 ? 5: 4
export const WasteWater = ({}: {}) => {
  const [curveData, setCurveData] = useState<any | undefined>()
  const [pointData, setPointData] = useState<any | undefined>()
  const [showAll, setShowAll] = useState<boolean>(true)

  useEffect(() => {
    fetch(
      'https://ta-interaktiv.storage.googleapis.com/corona-dashboard/ZH-WasteWater.json'
    )
      .then(response => response.json())
      .then(data => {
    
        data = data.filter(f =>
          [
            'Bülach',
            'Dietikon',
            'Illnau-Effretikon',
            'Winterthur',
            'Zürich (Werdhölzli)'
          ].includes(f.station)
        )
        setCurveData(
          groups(
            data.filter(f => f.ave7 && new Date(f.d) >= new Date('2021-11-01')),
            d => d.station
          ) as any
        )
        setPointData(
          groups(
            data.filter(f => new Date(f.d) >= new Date('2021-11-01')),
            d => d.station
          ) as any
        )
      })
  }, [])
  console.log(curveData)
  return (
    <>
      <div className='ui container'>
        <div className='WasteWater'>
          <Chart
            title='Corona-Gensequenzen im Abwasser von Kläranlagen'
            sub={
              'Gemessene Gensequenzen in 100 Milliarden pro Tag, Wochenschnitt' +
              (curveData
                ? ', bis ' +
                  formatSwissDate(curveData[0][1][curveData[0][1].length - 1].d)
                : '')
            }
            source={
              <>
                Quelle:{' '}
                <a
                  href='https://raw.githubusercontent.com/openZH/covid_19_wastewater_monitoring_ZH/master/COVID19_Abwassermonitoring.csv'
                  target='_blank'
                  rel='noreferrer'
                >
                  Gesundheitsdirektion Kanton Zürich
                </a>
              </>
            }
          >
            <div className='chartwrapper'>
              {curveData &&
                pointData &&
                curveData.map((m, i) => {
                  console.log(m)

                  if (i > showMax && !showAll) return null
                  if ((i === showMax && !showAll) )
                    return (
                      <React.Fragment key={'WasteWater_' + i}>
                        <button
                          className='basic'
                          onClick={() => setShowAll(!showAll)}
                        >
                          {!showAll ? 'Mehr anzeigen' : 'Weniger anzeigen'}
                        </button>
                      </React.Fragment>
                    )
                  if (!m[0]) return null

                  return (
                    <div className='wastechart' key={'WasteWater_' + i}>
                      <div className='wastettitle'>{m[0]}</div>
                      <LineAndPoints
                        data={[
                          m[1]
                            .filter((f, i) => i < m[1].length - 1)
                            .map(m => {
                              return { d: m.d, v: m.ave7 }
                            }),
                          pointData[i][1].map(m => {
                            return { d: m.d, v: m.v }
                          })
                        ]}
                        yDomain={[1000, 0]}
                        xDomain={[new Date(m[1][0].d), addDays(21, new Date())]}
                        yTicks={{
                          lines: [0, 250, 500, 750],
                          text: [250, 500, 750]
                        }}
                        height={140}
                        xTicks={{
                          text: ['2022-01-01', '2023-01-01'],
                          lines: ['2022-01-01', '2023-01-01']
                        }}
                        className='waste'
                      />
                    </div>
                  )
                })}
            </div>
          </Chart>
        </div>
      </div>
    </>
  )
}
